import { takeEvery, fork, put, all, call } from "redux-saga/effects";
import {
	SR_PURCHASE_INDENTS_LIST,
	SR_VENDORS_LIST,
	GET_SR_VENDORS_DATA,
	SR_REQUESTFORQUOTATION_ADD,
	SR_RFQ_LIST,
	SR_RFQ_LIST_COUNT,
	RFQ_SR_ROW_DATA,
	RF_SR_MODEL_LIST_OPEN,
	GENERATE_RFQ_PDF,
	FILTERS_SHOW_SR_RIGHT_SIDEBAR,
	FILTERS_HIDE_SR_RIGHT_SIDEBAR,
	ADD_SR_VENDORS,
	SR_CODE_DETAILS,
	SR_PI_DETAILS_MODEL_OPEN,
	MR_SR_ITEM_IMAGES,
	RFQ_PI_ITEM_CANCEL,
	RFQ_PI_SR_ITEM_CANCEL,
} from "./actionTypes";
import {
	apiError,
	getPuchaseIndentItemsSuccessful,
	VendorsListSuccessful,
	VendorDataSuccessful,
	RFQRequestListSuccessful,
	getRFQRequestdata,
	getRFQRequestdataSuccessful,
	downloadRFQButton,
	getMRCodeDetailsSuccessful,
	PIRowDataSuccessful,
	RFQListCountSuccessful,
	getMRItemImgesSuccessful,
	getPurchaseIndentItems,
} from "./actions";

import {
	postAdd,
	getList,
	getParamsList,
	getDownloadFile,
	postEdit,
	// postEdit,
	// postDelete,
} from "../../helpers/Helper";
import swal from "sweetalert";
import Swal from "sweetalert2";
import moment from "moment";
function* getPurchaseIndentsList({ payload: { data } }) {
	var params = {};
	for (const k in data) {
		if (Object.hasOwnProperty.call(data, k)) {
			if (k === "picurrentSort" || k === "sortOrder") {
				params.ordering = data.sortOrder + data.picurrentSort;
			} else {
				if (data[k] !== "" && k !== "no_of_pages") {
					if (k === "start_date") {
						params[k] = moment(data[k]).format("YYYY-MM-DD");
					} else if (k === "end_date") {
						params[k] = moment(data[k]).format("YYYY-MM-DD");
					} else if (k == "month") {
						params[k] = moment(data[k]).format("MM-YYYY");
					} else {
						params[k] = data[k];
					}
				}
			}
		}
	}
	try {
		const response = yield call(
			getParamsList,
			"/serviceindent/rfqlistitem",
			params
		);
		console.log("response", response);
		console.log("params", params);
		yield put(getPuchaseIndentItemsSuccessful(response));
	} catch (error) {
		yield put(apiError(error));
	}
}
function* getSelectedProductVendorsList({ payload: { data } }) {
	var params = {};

	for (const k in data) {
		if (Object.hasOwnProperty.call(data, k)) {
			if (data[k] !== "") {
				params[k] = data[k];
			}
		}
	}
	try {
		const response = yield call(
			getParamsList,
			"/masters/mini/vendors/",
			params
		);
		// const response = yield call(
		//   postAdd,
		//   "/masters/mini/vendors/byproducts",
		//   data
		// );
		yield put(VendorsListSuccessful(response));
	} catch (error) {
		yield put(apiError(error));
	}
}
function* GetVendorData({ payload: { VendId } }) {
	try {
		const response = yield call(getList, "/masters/vendors/" + VendId, {});
		yield put(VendorDataSuccessful(response));
	} catch (error) {
		yield put(apiError(error));
	}
}
function* RequestForQuotationAdd({ payload: { data } }) {
	try {
		const response = yield call(
			postAdd,
			"/servicerequestforquotation/",
			data
		);

		if (response.status === 201) {
			swal("Your Request Added Successfully.!", {
				icon: "success",
			});
			yield put(downloadRFQButton(response.data.id));
		} else {
			swal("Sorry! Unable to ad Request. Please Try Again!", {
				icon: "error",
			});
		}
	} catch (error) {
		swal(error[0], {
			icon: "error",
		});
	}
}
function* getRFQList({ payload: { data } }) {
	var params = {};
	for (const k in data) {
		if (Object.hasOwnProperty.call(data, k)) {
			if (k === "srfqstatus") {
				if (data.srfqstatus[0] !== 0) {
					params.srfqstatus = data.srfqstatus.join(",");
				}
			} else if (k === "currentSort" || k === "sortOrder") {
				params.ordering = data.sortOrder + data.currentSort;
			} else {
				if (data[k] !== "") {
					params[k] = data[k];
				}
			}
		}
	}
	try {
		const response = yield call(
			getParamsList,
			"/servicerequestforquotation/list",
			params
		);
		yield put(RFQRequestListSuccessful(response));
	} catch (error) {
		yield put(apiError(error));
	}
}
function* getRFQListCount({ payload: { data } }) {
	var params = {};

	for (const k in data) {
		if (Object.hasOwnProperty.call(data, k)) {
			if (k === "srfqstatus") {
				if (data.srfqstatus[0] !== 0) {
					params.srfqstatus = data.srfqstatus.join(",");
				}
			} else if (k === "currentSort" || k === "sortOrder") {
				params.ordering = data.sortOrder + data.currentSort;
			} else {
				if (data[k] !== "" && k !== "no_of_pages") {
					params[k] = data[k];
				}
			}
		}
	}

	try {
		const response = yield call(
			getParamsList,
			"/servicerequestforquotation/count/list",
			params
		);

		yield put(RFQListCountSuccessful(response));
	} catch (error) {
		yield put(apiError(error));
	}
}
function* getRFQRowdata({ payload: { rfqId } }) {
	try {
		const response = yield call(
			getList,
			"/servicerequestforquotation/" + rfqId,
			{}
		);
		yield put(getRFQRequestdataSuccessful(response));
	} catch (error) {
		yield put(apiError(error));
	}
}
function* AddVendorsData({ payload: { data, rfqId } }) {
	try {
		const response = yield call(
			postEdit,
			"/servicerequestforquotation/addvendors/" + rfqId,
			data
		);
		if (response.status === 200) {
			swal(" Vendors Added Successfully.!", {
				icon: "success",
			});
			yield put(getRFQRequestdata(rfqId));
		} else {
			swal("Sorry! Unable to add Vendors. Please Try Again!", {
				icon: "error",
			});
		}
	} catch (error) {
		yield put(apiError(error));
		Swal.fire({
			icon: "error",
			text: "Sorry! Vendor is not allowed in Resend RFQ",
		});
	}
}
function* GetPIDetails({ payload: { PIID } }) {
	try {
		const response = yield call(getList, "/serviceindent/" + PIID, {});
		yield put(PIRowDataSuccessful(response));
	} catch (error) {
		yield put(PIRowDataSuccessful(null));
		swal("Error in getting PI data from the Server", {
			icon: "error",
		});
	}
}
function* getMRCodeDetails({ payload: { ItemId } }) {
	try {
		const response = yield call(
			getList,
			"/servicerequestforquotation/srcodebysrfqitem/" + ItemId,
			{}
		);
		yield put(getMRCodeDetailsSuccessful(response));
	} catch (error) {
		yield put(apiError(error));
	}
}
function* generateRFQPDF({ payload: { RFQId } }) {
	try {
		yield call(getDownloadFile, "/servicerequestforquotation/pdf/" + RFQId);

		// generateRFQasPDF("RFQ",response)
	} catch (error) {
		yield put(apiError(error));
	}
}
function* getPIMRItemImges({ payload: { PIItemId } }) {
	try {
		const response = yield call(
			getList,
			"/purchaseindent/mrcodebypiitem/" + PIItemId,
			{}
		);
		yield put(getMRItemImgesSuccessful(response));
	} catch (error) {
		yield put(apiError(error));
	}
}

function* PIItemCancel({ payload: { data } }) {
	try {
		const response = yield call(
			postAdd,
			"/purchaseindent/purchaseuserapprove",
			data
		);

		if (response.status === 201) {
			if (data.pistatus === 10) {
				swal(
					" Your Purchase Indent Item has been Cancle sucessfully!",
					{
						icon: "success",
					}
				);
			}

			yield put(getPurchaseIndentItems({ page: 1 }));
		} else {
			swal(" Sorry! Your Purchase Indent Item has been not changed!", {
				icon: "success",
			});
		}
	} catch (error) {
		swal("Sorry! Error in getting from the Server", {
			icon: "error",
		});

		yield put(apiError(error));
	}
}

/**
 * CProduct the class on body
 * @param {*} cssClass
 */
function manageBodyClass(cssClass, action = "toggle") {
	switch (action) {
		case "add":
			if (document.body) document.body.classList.add(cssClass);
			break;
		case "remove":
			if (document.body) document.body.classList.remove(cssClass);
			break;
		default:
			if (document.body) document.body.classList.toggle(cssClass);
			break;
	}

	return true;
}
function* FilterShowRightSidebar() {
	try {
		yield call(manageBodyClass, "filters-right-bar-enabled");
	} catch (error) {}
}
function* FilterHideRightSidebar() {
	try {
		yield call(manageBodyClass, "filters-right-bar-enabled", "remove");
	} catch (error) {}
}
export function* watchgetPurcahseIndentList() {
	yield takeEvery(SR_PURCHASE_INDENTS_LIST, getPurchaseIndentsList);
}
export function* watchgetSelectedProductVendors() {
	yield takeEvery(SR_VENDORS_LIST, getSelectedProductVendorsList);
}
export function* watchGetVendorData() {
	yield takeEvery(GET_SR_VENDORS_DATA, GetVendorData);
}
export function* watchRequestForQuotationAdd() {
	yield takeEvery(SR_REQUESTFORQUOTATION_ADD, RequestForQuotationAdd);
}
export function* watchgetRFQList() {
	yield takeEvery(SR_RFQ_LIST, getRFQList);
}
export function* watchgetRFQCount() {
	yield takeEvery(SR_RFQ_LIST_COUNT, getRFQListCount);
}
export function* watchgetRFQRowdata() {
	yield takeEvery(RFQ_SR_ROW_DATA, getRFQRowdata);
}
export function* watchmodellist() {
	yield takeEvery(RF_SR_MODEL_LIST_OPEN, getRFQRowdata);
}
export function* watchgenerateRFQPDF() {
	yield takeEvery(GENERATE_RFQ_PDF, generateRFQPDF);
}
export function* watchFilterShowRightSidebar() {
	yield takeEvery(FILTERS_SHOW_SR_RIGHT_SIDEBAR, FilterShowRightSidebar);
}
export function* watchfilterHideRightSidebarr() {
	yield takeEvery(FILTERS_HIDE_SR_RIGHT_SIDEBAR, FilterHideRightSidebar);
}
export function* watchAddVendors() {
	yield takeEvery(ADD_SR_VENDORS, AddVendorsData);
}
export function* watchGetPIDetails() {
	yield takeEvery(SR_PI_DETAILS_MODEL_OPEN, GetPIDetails);
}
export function* watchgetMRCodeDetails() {
	yield takeEvery(SR_CODE_DETAILS, getMRCodeDetails);
}
export function* watchgetMRItemData() {
	yield takeEvery(MR_SR_ITEM_IMAGES, getPIMRItemImges);
}
export function* watchPIItemCancel() {
	yield takeEvery(RFQ_PI_SR_ITEM_CANCEL, PIItemCancel);
}
function* SRRequestForQuotationSaga() {
	yield all([
		fork(watchgetPurcahseIndentList),
		fork(watchgetSelectedProductVendors),
		fork(watchGetVendorData),
		fork(watchgetRFQList),
		fork(watchgetRFQRowdata),
		fork(watchgenerateRFQPDF),
		fork(watchmodellist),
		fork(watchAddVendors),
		fork(watchgetRFQCount),
		fork(watchRequestForQuotationAdd),
		fork(watchFilterShowRightSidebar),
		fork(watchfilterHideRightSidebarr),
		fork(watchGetPIDetails),
		fork(watchgetMRCodeDetails),
		fork(watchgetMRItemData),
		fork(watchPIItemCancel),
	]);
}

export default SRRequestForQuotationSaga;
